// Argon Dashboard 2 MUI base styles
import colors from "assets/theme-dark/base/colors";

// Argon Dashboard 2 MUI helper functions

const { transparent, text } = colors;

const select = {
    styleOverrides: {
        select: {
            display: "grid",
            alignItems: "center",
            padding: `0 0 !important`,
            // padding: `0 ${pxToRem(12)} !important`,
            width: "100% !important",

            "& .Mui-selected": {
                backgroundColor: transparent.main,
                width: "max-content !important",
            },
        },

        selectMenu: {
            background: "none",
            height: "none",
            minHeight: "none",
            overflow: "unset",
            color: text.main
        },

        icon: {
            display: "block",
            color: text.main
        },
    },
};

export default select;
